import { FC } from 'react'
import { VscEdit } from 'react-icons/vsc'
import CustomText from '../../CustomText'
import BackButton from '../BackButton/BackButton'

type InfoViewProps = {
  label: string
  name: string
  email: string
  mobile: string
  idNumber: string
  account: string
  property: string
  children?: React.ReactNode
  handleEdit?: () => void
}

export const InfoView: FC<InfoViewProps> = ({
  label,
  name,
  email,
  mobile,
  idNumber,
  account,
  property,
  children,
  handleEdit
}: InfoViewProps) => {
  return (
    <div
      className={`grow h-auto flex flex-col gap-y-4 p-[20px] rounded-2xl bg-[#FCFBF6] border-solid border-[1.5px] border-[#e4e4e4]`}
    >
      <div className="w-full h-auto flex flex-row justify-between">
        <CustomText
          textLabel={label}
          fontWeight={`font-semibold`}
          fontSize="text-[14px]"
          fontColor={`text-black`}
        />

        {handleEdit && (
          <div className="w-fit h-fit flex flex-row justify-between" onClick={handleEdit}>
            <BackButton label="Edit" handleClick={handleEdit} isBack={false}>
              <VscEdit className="w-[20px] h-[20px]" color="#000000" />
            </BackButton>
          </div>
        )}
      </div>

      <div className="w-full h-auto flex flex-row justify-between">
        <CustomText
          textLabel={`Name`}
          fontWeight={`font-regular`}
          fontSize="text-[12px]"
          fontColor={`text-black`}
        />
        <CustomText
          textLabel={name}
          fontWeight={`font-bold`}
          fontSize="text-[14px]"
          fontColor={`text-black`}
        />
      </div>
      <div className="w-full h-auto flex flex-row justify-between">
        <CustomText
          textLabel={`Email`}
          fontWeight={`font-regular`}
          fontSize="text-[12px]"
          fontColor={`text-black`}
        />
        <CustomText
          textLabel={email}
          fontWeight={`font-bold`}
          fontSize="text-[14px]"
          fontColor={`text-black`}
        />
      </div>
      <div className="w-full h-auto flex flex-row justify-between">
        <CustomText
          textLabel={`Mobile`}
          fontWeight={`font-regular`}
          fontSize="text-[12px]"
          fontColor={`text-black`}
        />
        <CustomText
          textLabel={mobile}
          fontWeight={`font-bold`}
          fontSize="text-[14px]"
          fontColor={`text-black`}
        />
      </div>
      <div className="w-full h-auto flex flex-row justify-between">
        <CustomText
          textLabel={`ID number`}
          fontWeight={`font-regular`}
          fontSize="text-[12px]"
          fontColor={`text-black`}
        />
        <CustomText
          textLabel={idNumber}
          fontWeight={`font-bold`}
          fontSize="text-[14px]"
          fontColor={`text-black`}
        />
      </div>
      <div className="w-full h-auto flex flex-row justify-between">
        <CustomText
          textLabel={`Account`}
          fontWeight={`font-regular`}
          fontSize="text-[12px]"
          fontColor={`text-black`}
        />
        <CustomText
          textLabel={account}
          fontWeight={`font-bold`}
          fontSize="text-[14px]"
          fontColor={`text-black`}
        />
      </div>
      <div className="w-full h-auto flex flex-row justify-between">
        <CustomText
          textLabel={`Property`}
          fontWeight={`font-regular`}
          fontSize="text-[12px]"
          fontColor={`text-black`}
        />
        <CustomText
          textLabel={property}
          fontWeight={`font-bold`}
          fontSize="text-[14px]"
          fontColor={`text-black`}
        />
      </div>

      {children}
    </div>
  )
}

export default InfoView
